import { Overview } from "./Overview";
import { Strategy } from "./Strategy";
import { Playbook } from "./Playbook";
import { Scenarios } from "./Scenarios";
import { MeetingPack } from "./MeetingPack";

export type NegotiationPackTab = "overview" | "strategy" | "playbook" | "scenarios" | "meetingpack";

interface NegotiationPackDetailsProps {
  tab: NegotiationPackTab;
  setTab: (tab: NegotiationPackTab) => void;
  onSkip: () => void;
}

const TABS: Array<{ key: NegotiationPackTab; label: string }> = [
  { key: "overview", label: "Overview" },
  { key: "strategy", label: "Strategy" },
  { key: "playbook", label: "Playbook" },
  { key: "scenarios", label: "Scenarios" },
  { key: "meetingpack", label: "Meeting Pack" },
];

export function NegotiationPackDetails({ tab, setTab, onSkip }: NegotiationPackDetailsProps) {
  const nextStep = {
    overview: { tab: "strategy" as const, label: "Build my strategy" },
    strategy: { tab: "playbook" as const, label: "Build my playbook" },
    playbook: { tab: "scenarios" as const, label: "Build my scenarios" },
    scenarios: { tab: "meetingpack" as const, label: "Start Meeting Mode" },
  }[tab as "overview" | "strategy" | "playbook" | "scenarios"];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div className="npv-tab-list justify-between" style={{ display: "flex", gap: 4, flexWrap: "wrap" }} role="tablist" aria-label="Negotiation sections">
        <span className="npv-tab-indicator flex items-center gap-2" aria-hidden="true">
          {TABS.map((item) => {
            const active = tab === item.key;
            return (
              <button
                key={item.key}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => setTab(item.key)}
                style={{
                  border: active ? "none" : "1px solid #E2E8F0",
                  cursor: "pointer",
                  background: active ? "#1A1040" : "#FFFFFF",
                  color: active ? "#FFFFFF" : "#636B7A",
                  borderRadius: 20,
                  padding: "5px 20px",
                  fontSize: 12,
                  fontWeight: active ? 700 : 500,
                  fontFamily: "'Inter', system-ui, sans-serif",
                }}
              >
                {item.label}
              </button>
            );
          })}
        </span>
        
        {nextStep && (
          <div className="npv-actions-row">
            {tab !== "scenarios" && (
              <button type="button" onClick={onSkip} className="npv-btn npv-btn--outline">
                Click here to generate meeting pack
              </button>
            )}
            <button type="button" onClick={() => setTab(nextStep.tab)} className="npv-btn npv-btn--gradient">
              {nextStep.label} <span aria-hidden="true">→</span>
            </button>
          </div>
        )}
      </div>
      {tab === "overview" && <Overview />}
      {tab === "strategy" && <Strategy />}
      {tab === "playbook" && <Playbook />}
      {tab === "scenarios" && <Scenarios />}
      {tab === "meetingpack" && <MeetingPack />}
    </div>
  );
}
